import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('group_members', '/plans/group_members', 'group_members')
const actions = generator.generate()

export default actions
